var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status == 'OLST_CANCELADA')?_c('v-icon',{attrs:{"title":"Activar","color":"green"},on:{"click":function($event){return _vm.statusOrder(false)}}},[_vm._v(" mdi-check-circle-outline ")]):_c('v-icon',{attrs:{"title":"Desactivar","color":"red"},on:{"click":function($event){return _vm.statusOrder(true)}}},[_vm._v(" mdi-cancel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }